var React = require('react');

function UbiquitiIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.009 7.537h-1.754V5.778h1.754v1.76zm1.751 2.659H13.01v-1.76h1.751v1.76zM13 12.409h-1.734v-1.76h1.733v1.76zm-1.753 2.64H9.514v-1.76h1.732v1.76zm-3.495-9.27H6V4h1.751v1.778zm25.57 15.901L34 19.43V4.018c-7.935 0-8.762 3.091-8.762 6.042v16.925c0 .876-.083 1.806-.258 2.717 4.208-.778 6.953-3.42 8.341-8.022zm-22.066-4.874h-1.75v1.76H7.751v-9.7H6v14.502C6 30.581 11.198 36 20.001 36c0 0-5.24-2.934-5.24-9.015V14.168h-1.752v6.558h-1.755v-3.92zm-.01-7.492h-1.73v-1.76h1.73v1.76zm4.456 19.755c1.393.872 3.191 1.474 5.528 1.582 6.476.296 10.879-2.493 12.77-8.761v1.479c0 6.823-4.658 12.041-12.616 12.581l-1.04-.582c-.17-.097-3.699-2.14-4.642-6.299z","fill":"#fff"}));
}

UbiquitiIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = UbiquitiIcon;

UbiquitiIcon.default = UbiquitiIcon;
